/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Snapshotform_Validation_Nonnegative3Inputs */

const en_coinvestments_report_snapshotform_validation_nonnegative3 = /** @type {(inputs: Coinvestments_Report_Snapshotform_Validation_Nonnegative3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Must be 0 or greater`)
};

/**
* | output |
* | --- |
* | "Must be 0 or greater" |
*
* @param {Coinvestments_Report_Snapshotform_Validation_Nonnegative3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_snapshotform_validation_nonnegative3 = /** @type {((inputs?: Coinvestments_Report_Snapshotform_Validation_Nonnegative3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Snapshotform_Validation_Nonnegative3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_snapshotform_validation_nonnegative3(inputs)
});
export { coinvestments_report_snapshotform_validation_nonnegative3 as "coInvestments_report_snapshotForm_validation_nonNegative" }